import React from "react";
import { Award } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";

export const TopRatedBadge = ({ rating, testId, className = "" }: { rating?: { avg: number; count: number } | null; testId: string; className?: string }) => {
  const { t } = usePrefs();
  if (!rating) return null;
  return (
    <span data-testid={testId} title={t("top.tip").replace("{avg}", String(rating.avg)).replace("{n}", String(rating.count))}
      className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-300 to-amber-500 text-amber-950 px-2.5 py-1 text-xs font-black shadow-lg shadow-amber-500/30 ${className}`}>
      <Award className="h-3.5 w-3.5" />{t("top.label")} · {rating.avg}
    </span>
  );
};
